import React from "react";
import { compose } from "recompose";
import { connect } from "react-redux";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import propertyMarker from "../../assets/images/rex/homeGroupWhite.png";
import { makeStyles } from "@material-ui/styles";
import { googleMapsApiKey } from "index";

// styles for Marker component image
const useStyles = makeStyles(theme => ({
  markerClass: {
    background: 'rgb(48, 128, 133)',
    'border-radius': '4px',
    'margin-left': '20px',
    'margin-bottom': '3px',
    padding: '2px 3px 2px 23px',
    color: 'white',
    '&::before': {
      content: '""',
      background: `center / contain no-repeat url(${propertyMarker})`,
      position: 'absolute',
      left: '23px',
      top: '40px',
      width: '17px',
      height: '17px'
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      left: '25px',
      bottom: '32px',
      border: '5px solid transparent',
      'border-top': '5px solid rgb(48, 128, 133)',
    },
  },
}));

const defaultZoom = 4;
const defaultCenter = {
  lat: 33.74944855312232,
  lng: -97.69366152343753
};
const padding = {
  top: 16,
  left: 16,
  bottom: 16,
  right: 16
}

const libraries = ['geometry', 'drawing', 'places'];

function Gmap(props) {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey,
    libraries,
    version: '3.64'
  })

  const mapRef = React.useRef(null);
  const iconUrl = propertyMarker;
  const classes = useStyles();

    function getMarkers(activeWorkflowTasks) {
      const stateMarkers = {};
      for (const stateData of activeWorkflowTasks) {
        if (stateMarkers[stateData.state] === undefined) {
          stateMarkers[stateData.state] = {};
          stateMarkers[stateData.state] = Object.assign(stateMarkers[stateData.state], stateData);
        } else {
          stateMarkers[stateData.state].latitude = (stateMarkers[stateData.state].latitude + stateData.latitude) / 2;
          stateMarkers[stateData.state].longitude = (stateMarkers[stateData.state].longitude + stateData.longitude) / 2;

          stateMarkers[stateData.state].opportunitiesCount += stateData.opportunitiesCount;
        }
      }
      // This changes map's zoom level depending on which filters were selected.
      if(mapRef.current) {
        mapRef.current.fitBounds(getDefaultBounds(props.activeWorkflowTasks), padding);
      }
      return Object.values(stateMarkers).map(t => {
        const { latitude, longitude, opportunitiesCount = '' } = t;

        return <Marker
          key={latitude}
          position={{lat: latitude, lng: longitude}}
          label={{
            text: opportunitiesCount.toString(),
            className: classes.markerClass,
            color: 'fff',
          }}
          icon={iconUrl}
        />;
      });
  }

  function getDefaultBounds(activeWorkflowTasks) {
    let bounds = new window.google.maps.LatLngBounds();
    if (activeWorkflowTasks.length > 0) {
      activeWorkflowTasks.forEach(property => {
        if (property.latitude && property.longitude) {
          let position = new window.google.maps.LatLng(property.latitude, property.longitude);
          bounds.extend(position);
        }
      });
    } else {
      bounds = getMaxBounds();
    }

    return bounds;
  }

  function getMaxBounds() {
    const bounds = new window.google.maps.LatLngBounds();
    const southWest = new window.google.maps.LatLng(24,-64);
    const northEast = new window.google.maps.LatLng(50,-128);
    bounds.extend(southWest);
    bounds.extend(northEast);
    return bounds;
  }

  const onLoad = React.useCallback(map => {
    mapRef.current = map;
  }, [])
  if (loadError) {
    console.log('error loading map');
    return null;
  }

  return (
    isLoaded ?
    <GoogleMap
      center={defaultCenter}

      zoom={defaultZoom}
      onLoad={onLoad}
      mapContainerStyle={{ height: `100%`, width: `100%`, minHeight: '100px' }}
      options={{
        restriction:{
          latLngBounds: getMaxBounds(),
          strictBounds: false
        },
        cameraControl: false,
        zoomControl: true,
        draggable: true,
        rotateControl: false,
        scaleControl: false,
        streetViewControl: false,
        panControl: false,
        disableDefaultUI: true,
        maxZoom: 18,
        minZoom: 4
      }}
    >
      {getMarkers(props.activeWorkflowTasks)}

    </GoogleMap>
    : <div>Loading Map</div>
  )
}

function mapState(state) {
  return {

  };
}

const mapDispatch = {

}

export default compose(
    connect(mapState, mapDispatch)
)(Gmap);
